import { render, staticRenderFns } from "./OverviewTabContent.vue?vue&type=template&id=6d2a582a"
import script from "./OverviewTabContent.vue?vue&type=script&lang=js"
export * from "./OverviewTabContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports